import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { Seo, Layout } from '@/components/generals'
import { KitCards } from '@/components/landing/kit-cards'

const benefits = [
    'ضمانت کتبی یک‌ساله قطعات مکانیکی',
    'پنج سال خدمات پس از فروش دستگاه',
    'دو سال تأمین قطعات یدکی الکترونیک',
    'برش رایگان پروفیل به اندازهٔ دلخواه',
    'مونتاژ دستگاه در صورت درخواست',
    'آماده‌سازی سفارش در ۱ تا ۴ روز کاری',
    'پرداخت آنلاین یا کارت‌به‌کارت'
]

const learningPaths = [
    { id: 'w-node-fdd6b3f9-ad6d-93e1-6fcb-85fbc3858e73-248d6fb6', title: 'شروع کار با CNC', subtitle: 'از فایل طراحی تا اولین برش' },
    { id: 'w-node-_725e9958-a1cb-101d-3e2b-cea8a5b9c0c7-248d6fb6', title: 'راه‌اندازی و تنظیم', subtitle: 'کنترلر، نرم‌افزار و کالیبراسیون' },
    { id: 'w-node-_73f158c9-d084-628e-5757-50febde5ec6a-248d6fb6', title: 'مکانیک و حرکت', subtitle: 'پروفیل، چرخ V و لیدسکرو' },
    { id: 'w-node-cbb4e338-487f-fee9-3f18-49fbb39b5830-248d6fb6', title: 'تیغه و متریال', subtitle: 'فید، دور و انتخاب تیغه' }
]

const logoIds = [
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcd8-248d6fb6',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcda-248d6fb6',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcdc-248d6fb6',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dcde-248d6fb6',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce0-248d6fb6',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce2-248d6fb6',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce4-248d6fb6',
    'w-node-f078fdf9-afcd-dd23-e056-d7d58c77dce6-248d6fb6'
]

const About: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='درباره ما' description='OpenBuilds.ir فروشگاه آنلاین قطعات و کیت دستگاه CNC است: پروفیل شیاردار مهندسی، موتور، درایور، کنترلر و دستگاه‌های رومیزی بر پایهٔ طرح‌های متن‌باز OpenBuilds، با ارسال از تهران.' />

            {/* About hero */}
            <div className='section'>
                <div className='container about'>
                    <div className='features-hero-holder'>
                        <div className='about-hero-container'>
                            <div className='about-hero-holder'>
                                <div className='about-hero-text-holder'>
                                    <div className='animate-on-load-01'>
                                        <h1 className='white-title'>ابزار ساختن، از تهران</h1>
                                    </div>
                                    <div className='animate-on-load-02'>
                                        <p>OpenBuilds.ir فروشگاه آنلاین قطعات و کیت دستگاه CNC است: پروفیل شیاردار مهندسی، موتور، درایور، کنترلر و دستگاه‌های رومیزی بر پایهٔ طرح‌های متن‌باز OpenBuilds. همهٔ سفارش‌ها از انبار تهران ارسال می‌شوند.</p>
                                    </div>
                                </div>
                                <div className='about-hero-content-holder'>
                                    <div className='animate-on-load-03'>
                                        <div className='w-layout-grid about-hero-content'>
                                            <div id='w-node-cf5e4ca1-9480-830e-b60e-6d46dea3dc58-248d6fb6' className='about-hero-content-wrapper'>
                                                <div className='about-hero-title'>دستگاه CNC رومیزی</div>
                                                <p className='grey-text'>MiniMill، C-Beam Machine و C-Beam XLarge، به‌صورت کیت قطعات یا مونتاژشده.</p>
                                            </div>
                                            <div id='w-node-_4251a876-0729-5d4a-eb72-e0d80c50ba6b-248d6fb6' className='about-hero-content-wrapper'>
                                                <div className='about-hero-title'>پروفیل شیاردار مهندسی</div>
                                                <p className='grey-text'>هفت مدل پروفیل با برش رایگان به اندازهٔ دلخواه.</p>
                                            </div>
                                            <div id='w-node-_6ecca6df-2a0f-fb0c-c590-081f4c1c12e4-248d6fb6' className='about-hero-content-wrapper'>
                                                <div className='about-hero-title'>موتور، درایور و کنترلر</div>
                                                <p className='grey-text'>هر آنچه برای ساخت یا ارتقای دستگاه خودتان لازم دارید، از موتور استپر NEMA 23 تا کنترلر MKS DLC32 و منبع تغذیه.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id='w-node-c59db0e2-42cb-45bb-b899-0a897bca219c-248d6fb6' className='about-hero-image-holder'>
                                <div className='animate-on-load-04'><img src='/images/About-Hero-Image.webp' loading='lazy' sizes='(max-width: 479px) 94vw, (max-width: 767px) 93vw, (max-width: 991px) 94vw, (max-width: 1439px) 35vw, 465.6015625px' srcSet='/images/About-Hero-Image-p-500.png 500w, /images/About-Hero-Image-p-800.png 800w, /images/About-Hero-Image.webp 976w' alt='' className='about-hero-image' /></div>
                            </div>
                        </div>
                    </div>
                    <div className='logo-grid-holder'>
                        <div className='w-layout-grid logo-grid'>
                            {logoIds.map((id, index) => (
                                <div key={id} id={id} className='logo-small-container'><img src={`/images/Logo0${index + 1}.svg`} loading='lazy' alt='' className='logo-small' /></div>
                            ))}
                        </div>
                        <div className='fade-in-move-on-scroll'>
                            <p>ساخته‌شده بر پایهٔ طرح‌های متن‌باز OpenBuilds</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Who we are */}
            <div className='section'>
                <div className='container'>
                    <div className='center-title'>
                        <div className='title-holder'>
                            <div className='fade-in-move-on-scroll'>
                                <h1 className='title'>برای هر سازنده، یک راه شروع</h1>
                            </div>
                            <div className='fade-in-move-on-scroll'>
                                <div className='experience-paragraph-holder'>
                                    <p>چه اولین دستگاهتان را می‌سازید و چه کارگاهتان را گسترش می‌دهید، قطعه و راهنمای لازم را اینجا پیدا می‌کنید.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='about-black-section'>
                        <div className='your-needs-section-container'>
                            <div className='w-layout-grid your-needs-section-grid'>
                                <div id='w-node-_0f36e23a-3fab-0fa0-e253-60a677d40cdb-248d6fb6' className='your-neeeds-content-holder'>
                                    <div className='fade-in-move-on-scroll'>
                                        <div className='gradient-small-text'>دربارهٔ ما</div>
                                    </div>
                                    <div className='fade-in-move-on-scroll'>
                                        <h2 className='white-title'>طرح‌های متن‌باز، قطعات آماده</h2>
                                    </div>
                                    <div className='fade-in-move-on-scroll'>
                                        <p>دستگاه‌ها و پروفیل‌های ما بر پایهٔ طرح‌های متن‌باز OpenBuilds, LLC هستند که تحت مجوز CC BY-SA 4.0 منتشر شده‌اند. ما قطعات را آماده می‌کنیم، به اندازه می‌بُریم، در صورت نیاز مونتاژ می‌کنیم و از انبار تهران برایتان می‌فرستیم.</p>
                                    </div>
                                    <div className='fade-in-move-on-scroll'>
                                        <div className='your-needs-button'>
                                            <Link href='/features' className='button w-button'>دیدن دستگاه‌ها</Link>
                                        </div>
                                    </div>
                                </div>
                                <div id='w-node-a3766d40-26e9-9090-447e-7a79ee3a5c9f-248d6fb6' className='your-needs-image-holder small-image'><img src='/images/Laptop-Image.webp' loading='lazy' sizes='(max-width: 479px) 94vw, (max-width: 767px) 92vw, (max-width: 1439px) 94vw, 1292px' srcSet='/images/Laptop-Image-p-500.jpg 500w, /images/Laptop-Image-p-800.jpg 800w, /images/Laptop-Image-p-1080.jpg 1080w, /images/Laptop-Image-p-1600.jpg 1600w, /images/Laptop-Image.webp 1920w' alt='' className='your-needs-image' /></div>
                            </div>
                        </div>
                        <div className='divider' />
                        <div className='your-needs-section-container'>
                            <div className='w-layout-grid your-needs-section-grid'>
                                <div id='w-node-_27dc780f-c46d-97fd-b84b-d41942f2a8cc-248d6fb6' className='your-neeeds-content-holder'>
                                    <div className='fade-in-move-on-scroll'>
                                        <div className='gradient-small-text'>چرا از ما بخرید</div>
                                    </div>
                                    <div className='fade-in-move-on-scroll'>
                                        <h2 className='white-title'>با خیال راحت بسازید</h2>
                                    </div>
                                    <div className='fade-in-move-on-scroll'>
                                        <p>ضمانت، پشتیبانی و زمان آماده‌سازی هر سفارش را از قبل و به‌صورت شفاف اعلام می‌کنیم.</p>
                                    </div>
                                </div>
                                <div id='w-node-c41893f6-77f1-aba0-bdf5-c28286a834ef-248d6fb6' className='about-black-list-holder'>
                                    <div className='about-black-list-container'>
                                        {benefits.map((benefit) => (
                                            <div key={benefit} className='about-black-list-wrapper'>
                                                <div className='about-black-list-icon-holder'><img src='/images/Black-Check.svg' loading='lazy' alt='' className='about-black-list-icon' /></div>
                                                <div>{benefit}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='about-company-image-holder'><img src='/images/About-Team-Image.webp' loading='lazy' sizes='(max-width: 479px) 94vw, (max-width: 767px) 93vw, (max-width: 1439px) 94vw, 1294px' srcSet='/images/About-Team-Image-p-500.jpg 500w, /images/About-Team-Image-p-800.jpg 800w, /images/About-Team-Image-p-1080.jpg 1080w, /images/About-Team-Image-p-1600.jpg 1600w, /images/About-Team-Image.webp 1839w' alt='' className='about-company-image' /></div>
                    </div>
                </div>
            </div>

            {/* Learning paths */}
            <div className='section'>
                <div className='container'>
                    <div className='center-title'>
                        <div className='title-holder'>
                            <div className='fade-in-move-on-scroll'>
                                <h1 className='title'>از کجا شروع کنیم؟</h1>
                            </div>
                            <div className='fade-in-move-on-scroll'>
                                <div className='experience-paragraph-holder'>
                                    <p>آموزش‌های ما در چهار بخش، از اولین برش تا انتخاب تیغه، همراهتان هستند.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='open-roles-holder'>
                        <div className='open-roles-container'>
                            {learningPaths.map((path) => (
                                <Link key={path.id} href='/blog' className='experience-wrapper w-inline-block'>
                                    <div id={path.id} className='experience-card'>
                                        <div className='light-wrapper-in-front'>
                                            <div className='light'>
                                                <div className='light-outside' />
                                            </div>
                                        </div>
                                        <div className='experience-card-content'>
                                            <div className='role-container'>
                                                <div className='role-title'>{path.title}</div>
                                                <div className='role-job-locaiton'>{path.subtitle}</div>
                                            </div>
                                        </div>
                                        <div className='light-wrapper'>
                                            <div className='light'>
                                                <div className='light-inside' />
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                            <div className='more-info-text'>سؤالی دارید که در آموزش‌ها نیست؟ <Link href='/contact' className='normal-link'>با ما در تماس باشید</Link> تا راهنمایی‌تان کنیم.</div>
                        </div>
                    </div>
                    <div className='open-roles-cta-holder'>
                        <div className='open-roles-cta-container'>
                            <div className='open-roles-cta'>
                                <div className='content-holder'>
                                    <h2 className='h3-title'>دستگاه مناسبتان را پیدا نکرده‌اید؟</h2>
                                    <div className='paragraph-open-roles'>
                                        <p>ابعاد کار و متریالی را که می‌خواهید ببُرید بگویید تا مناسب‌ترین دستگاه یا ترکیب قطعات را پیشنهاد کنیم.</p>
                                    </div>
                                </div>
                                <Link href='/contact' className='button w-button'>مشاورهٔ خرید</Link><img src='/images/Open-Roles-Illustaion.svg' loading='eager' alt='' className='open-roles-illustation' />
                            </div>
                            <div className='cta-gradient' />
                        </div>
                    </div>
                </div>
            </div>

            <KitCards />
        </Layout>
    )
}

export default About
